import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

// material-ui
import Box from '@mui/material/Box';

// project imports
import useConfig from 'hooks/useConfig';
import { USER_ROLES } from 'utils/role-utils';
import RoleGuard from 'utils/route-guard/RoleGuard';
import Container from '@mui/material/Container';
import Loader from 'components/Loader';
import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';
import { Theme, useMediaQuery } from '@mui/material';
import { AdminProvider } from 'contexts/AdminContext';
import AdminHeader from './Header';

// ==============================|| MAIN LAYOUT ||============================== //

export default function AdminLayout({ onlySpanish = false }: { onlySpanish?: boolean }) {
  const { i18n, onChangeLocalization } = useConfig();

  useEffect(() => {
    if (i18n !== 'es' && onlySpanish) {
      onChangeLocalization('es');
    }
  }, [i18n, onChangeLocalization, onlySpanish]);

  const { menuMasterLoading } = useGetMenuMaster();
  const downXL = useMediaQuery((theme: Theme) => theme.breakpoints.down('xl'));

  const { container, miniDrawer } = useConfig();

  useEffect(() => {
    if (!miniDrawer) {
      handlerDrawerOpen(!downXL);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downXL]);

  if (menuMasterLoading) return <Loader />;

  return (
    <RoleGuard allowedRoles={[USER_ROLES.ADMIN]}>
      <AdminProvider>
        <Box>
          <AdminHeader />
          <Box component="main" sx={{ width: '100%', flexGrow: 1, p: { xs: 2, sm: 3 }, pt: { xs: 10, sm: 11 } }}>
            <Container
              maxWidth={container ? 'xl' : false}
              sx={{
                ...(container && { pl: { xs: 0, sm: 2.5 }, pr: { xs: 0, sm: 0 }, pt: 2 }),
                position: 'relative',
                minHeight: 'calc(100vh - 150px)',
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <Outlet />
            </Container>
          </Box>
        </Box>
      </AdminProvider>
    </RoleGuard>
  );
}
